import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  AppBar,
  TablePagination,
  Toolbar,
  IconButton,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Autocomplete
} from '@mui/material'
import {
  Restaurant,
  ArrowBack,
  Save,
  Search,
  Person,
  Delete,
  Edit
} from '@mui/icons-material'

import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';

import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import PropTypes from 'prop-types';

import { format, parseISO } from 'date-fns';

import Collapse from '@mui/material/Collapse';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useAuth } from '../../contexts/AuthContext'
import api from '../../utils/axios'
import Form from './../../components/Form.css'

const Formedital = () => {
  const navigate = useNavigate()
  const { user, updateUser } = useAuth()
  console.log(user);

  const [rows, setRows] = useState([]);
  const [generosalimenticios, setGenerosalimenticios] = useState([]);
  const [selecionados, setSelecionados] = useState([]);
  const [alimentossalvos, setAlimentossalvos] = useState([]);

  // Novos estados para o item que está sendo adicionado
  const [alimentoSelecionado, setAlimentoSelecionado] = useState(null);
  const [quantidade, setQuantidade] = useState('');
  const [unidadeMedida, setUnidadeMedida] = useState('');
  const [valorProduto, setValorProduto] = useState('');
  const [editandoAlimentoId, setEditandoAlimentoId] = useState(null);

  const [itemEdit, setItemEdit] = useState(null);

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: {
      titulo: itemEdit?.titulo || '',
      descricao: itemEdit?.descricao || '',
      data_inicio: itemEdit?.data_inicio || '',
      data_fim: itemEdit?.data_fim || '',
      status: itemEdit?.status || '',      
      generosalimenticios: itemEdit?.generosalimenticios || ''
      // data_inscricao_caf: user?.data_inscricao_caf
      //   ? new Date(user.data_inscricao_caf).toISOString().split('T')[0]
      //   : ''
    }
  })
  
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  //   const { row } = props;
  const [open, setOpen] = React.useState(false);

  const [mode, setMode] = useState('');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (mode === "edit" && itemEdit) {
      reset(itemEdit); // <-- Aqui acontece a mágica
    } else if (mode === "create" || mode === "Busca" || !itemEdit) {
      console.log('resettttttt');
      const defaultValues = {
        titulo: '',
        descricao: '',
        data_inicio: '',
        data_fim: '',
        status:''
      };
      reset(defaultValues);
      setRows([]);
    }
  }, [itemEdit, reset, mode]);

  const handleEdit = async (item) => {
    console.log(item);
    setMode('edit');
    setItemEdit(item);
    reset(item);


    try {
      const response = await api.put('/editaisprodutos/list.php', {
        idedital: item.id,       
      })

      console.log(response);

      if (response.data.success) {
        // Assume response.data.alimentos contains { id, nome, quantidade, unidademedida }
        setAlimentossalvos(response.data.alimentos);
        setSelecionados(response.data.alimentos || []);
      } else {
        setError(response.data.message || 'Erro ao carregar itens do edital')
      }
    } catch (err) {
      setError(err.response?.data?.message || err)
    } finally {
      setLoading(false)
    }





    // if (eventos.length && eventosSalvos.length) {
    //   const selecionados = eventos.filter(e =>
    //     eventosSalvos.includes(e.id)
    //   );
    //   setEventosSelecionados(selecionados);
    // }

  }

  const onSubmit = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)


    console.log(data);
    console.log(mode);

    // Format selecionados to send to backend
    const generosalimenticiosData = (selecionados || []).map((item) => ({
      id_alimento: item.id_alimento || item.id,
      quantidade: item.quantidade,
      unidademedida: item.unidademedida,
      valor: item.valor
    })).filter(i => i.id_alimento);


    if (!data.id) {
      try {
        const response = await api.put('/editais/save.php', {
          // id: data.id,
          titulo: data.titulo,
          descricao: data.descricao,
          data_inicio: data.data_inicio,
          data_fim: data.data_fim,
          status: data.status,          
          generosalimenticios: generosalimenticiosData,


        })

        if (response.data.success) {
          setSuccess('Dados atualizados com sucesso!')
        } else {
          setError(response.data.message || 'Erro ao atualizar dados')
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao atualizar dados')
      } finally {
        setLoading(false)
      }
    } else {

      setMode('create');


      try {
        const response = await api.put('/editais/update.php', {
          id: data.id,
          titulo: data.titulo,
          descricao: data.descricao,
          data_inicio: data.data_inicio,
          data_fim: data.data_fim,
          status: data.status,          
          generosalimenticios: generosalimenticiosData,
        })

        console.log(response);

        if (response.data.success) {
          const updatedUser = { ...user, ...data }
          updateUser(updatedUser)
          setSuccess('Dados atualizados com sucesso!')
          // setTimeout(() => {
          //   navigate('/produtor')
          // }, 1500)
        } else {
          setError(response.data.message || 'Erro ao atualizar dados')
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao atualizar dados')
      } finally {
        setLoading(false)
      }
    }
  }

  const onSubmitBusca = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)
    setMode('');
    setPage(0);

    console.log(data);


    try {
      const response = await api.put('/editais/list.php', {
        id: user.id,
        titulo: data.titulo,
        descricao: data.descricao,
        data_inicio: data.data_inicio,
        data_fim: data.data_fim,
        status: data.status
      })

      console.log(response.data.editais);

      if (response.data.success) {
        const updatedUser = { ...user, ...data }
        console.log(updateUser);
        setRows(response.data.editais)
        // updateUser(updatedUser)
        // setSuccess('Dados atualizados com sucesso!')
        // setTimeout(() => {
        //   navigate('/produtor')
        // }, 1500)
      } else {
        setError(response.data.message || 'Erro ao atualizar dados')
      }
    } catch (err) {
      setError(err.response?.data?.message || err)
    } finally {
      setLoading(false)
    }
  }
  
  const handleAddAlimento = () => {
    if (!alimentoSelecionado) {
      setError('Selecione um gênero alimentício');
      return;
    }
    if (!quantidade || !unidadeMedida || !valorProduto) {
      setError('Informe a quantidade, unidade de medida e valor');
      return;
    }

    const jaExiste = selecionados.find(item =>
      (item.id_alimento || item.id) === alimentoSelecionado.id &&
      (item.id_alimento || item.id) !== editandoAlimentoId
    );
    if (jaExiste) {
      setError('Este gênero já foi adicionado');
      return;
    }

    const novoItem = {
      id_alimento: alimentoSelecionado.id,
      nome: alimentoSelecionado.nome,
      quantidade: quantidade,
      unidademedida: unidadeMedida,
      valor: valorProduto
    };

    if (editandoAlimentoId) {
      setSelecionados(selecionados.map(item =>
        (item.id_alimento || item.id) === editandoAlimentoId ? novoItem : item
      ));
    } else {
      setSelecionados([...selecionados, novoItem]);
    }

    setAlimentoSelecionado(null);
    setQuantidade('');
    setUnidadeMedida('');
    setValorProduto('');
    setEditandoAlimentoId(null);
    setError('');
  };

  const handleEditAlimento = (item) => {
    const id = item.id_alimento || item.id;
    const alimentoObj = generosalimenticios.find(a => a.id === id) || { id, nome: item.nome };
    setAlimentoSelecionado(alimentoObj);
    setQuantidade(item.quantidade);
    setUnidadeMedida(item.unidademedida);
    setValorProduto(item.valor);
    setEditandoAlimentoId(id);
    setError('');
  };

  const handleCancelarEdicaoAlimento = () => {
    setAlimentoSelecionado(null);
    setQuantidade('');
    setUnidadeMedida('');
    setValorProduto('');
    setEditandoAlimentoId(null);
    setError('');
  };

  const handleRemoveAlimento = (id) => {
    setSelecionados(selecionados.filter(item => (item.id_alimento || item.id) !== id));
    if (editandoAlimentoId === id) {
      handleCancelarEdicaoAlimento();
    }
  };

  const loadAlimentos = async () => {
    setLoading(true);
    try {
      const response = await api.put('/alimentos/list.php', {
        // id: user.id,
        // nome: data.nome,
        // cpf: data.cpf,
        // caf: data.caf,
        // data_inscricao_caf: data.data_inscricao_caf
      })

      console.log(response.data.alimentos);

      if (response.data.success) {
        // const updatedUser = { ...user, ...data }
        console.log(response.data.alimentos);
        setGenerosalimenticios(response.data.alimentos)
        // updateUser(updatedUser)
        // setSuccess('Dados atualizados com sucesso!')
        // setTimeout(() => {
        //   navigate('/produtor')
        // }, 1500)
      } else {
        setError(response.data.message || 'Erro ao atualizar dados')
      }
    } catch (err) {
      setError(err.response?.data?.message || err)
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => { loadAlimentos(); }, []);  

  const handleChange = (event) => {
    const { value } = event.target;
    setSelecionados(typeof value === "string" ? value.split(",") : value);
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/produtor')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <Person sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Meu Perfil
          </Typography>
        </Toolbar>
      </AppBar>

      {mode == 'create' || mode == 'edit'
        ?
        <Container sx={{ py: 3 }}>
          <Paper elevation={3} sx={{ p: 4 }}>
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Person sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
              <Typography variant="h5" gutterBottom>
                Editais
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            {success && (
              <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
                {success}
              </Alert>
            )}

            <form className='admin-form' onSubmit={handleSubmit(onSubmit)}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    className='col'
                    label="Título"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    {...register('titulo', {
                      minLength: {
                        value: 3,
                        message: 'Título deve ter no mínimo 3 caracteres'
                      }
                    })}
                    error={!!errors.titulo}
                    helperText={errors.titulo?.message}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    className='col'
                    label="Descrição"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    {...register('descricao', {
                      minLength: {
                        value: 3,
                        message: 'Descrição deve ter no mínimo 3 caracteres'
                      }
                    })}
                    error={!!errors.descricao}
                    helperText={errors.descricao?.message}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Data de Início"
                    type="date"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    {...register('data_inicio')}
                    error={!!errors.data_inicio}
                    helperText={errors.data_inicio?.message}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Data de Fim"
                    type="date"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    {...register('data_fim')}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    select
                    label="Status"
                    fullWidth
                    margin="normal"
                    value={itemEdit?.status || ''}
                    {...register('status')}
                    onChange={(e) => setItemEdit({ ...itemEdit, status: e.target.value })}
                  >
                    <MenuItem value="aberto">Aberto</MenuItem>
                    <MenuItem value="finalizado">Finalizado</MenuItem>
                  </TextField>
                </Grid>

                <Grid item xs={12}>
                  <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
                    Gêneros Alimentícios do Edital
                  </Typography>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={3}>
                      <Autocomplete
                        options={generosalimenticios}
                        getOptionLabel={(option) => option.nome || ''}
                        value={alimentoSelecionado}
                        isOptionEqualToValue={(option, value) => option.id === value?.id}
                        onChange={(event, newValue) => setAlimentoSelecionado(newValue)}
                        renderInput={(params) => (
                          <TextField {...params} label="Gênero Alimentício" fullWidth />
                        )}
                      />
                    </Grid>
                    <Grid item xs={6} md={2}>
                      <TextField
                        fullWidth
                        label="Quantidade"
                        type="number"
                        value={quantidade}
                        onChange={(e) => setQuantidade(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} md={2}>
                      <TextField
                        fullWidth
                        label="Unidade de Medida"
                        placeholder="Ex: kg, un, litro"
                        value={unidadeMedida}
                        onChange={(e) => setUnidadeMedida(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6} md={2}>
                      <TextField
                        fullWidth
                        label="Valor"
                        type="number"
                        placeholder="Ex: 12.50"
                        value={valorProduto}
                        onChange={(e) => setValorProduto(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} md={3}>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button
                          fullWidth
                          variant="outlined"
                          color="primary"
                          onClick={handleAddAlimento}
                          sx={{ height: '56px' }}
                        >
                          {editandoAlimentoId ? 'Salvar' : 'Adicionar'}
                        </Button>
                        {editandoAlimentoId && (
                          <Button
                            fullWidth
                            variant="text"
                            color="inherit"
                            onClick={handleCancelarEdicaoAlimento}
                            sx={{ height: '56px' }}
                          >
                            Cancelar
                          </Button>
                        )}
                      </Box>
                    </Grid>
                  </Grid>

                  {selecionados.length > 0 && (
                    <TableContainer component={Paper} sx={{ mt: 2 }}>
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell>Gênero</TableCell>
                            <TableCell align="right">Quantidade</TableCell>
                            <TableCell align="right">Unidade</TableCell>
                            <TableCell align="right">Valor</TableCell>
                            <TableCell align="center">Ações</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selecionados.map((item) => (
                            <TableRow
                              key={item.id_alimento || item.id}
                              selected={editandoAlimentoId === (item.id_alimento || item.id)}
                            >
                              <TableCell>{item.nome}</TableCell>
                              <TableCell align="right">{item.quantidade}</TableCell>
                              <TableCell align="right">{item.unidademedida}</TableCell>
                              <TableCell align="right">{item.valor}</TableCell>
                              <TableCell align="center">
                                <IconButton
                                  color="primary"
                                  onClick={() => handleEditAlimento(item)}
                                >
                                  <Edit />
                                </IconButton>
                                <IconButton
                                  color="error"
                                  onClick={() => handleRemoveAlimento(item.id_alimento || item.id)}
                                >
                                  <Delete />
                                </IconButton>
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Grid>

                <Grid item xs={12} md={12}>
                  {(mode !== 'create' && mode !== 'edit') ? (
                    <Button
                      onClick={() => setMode('create')}
                      variant="contained"
                      size="large"
                      sx={{ mt: 3 }}
                      startIcon={<Save />}
                      disabled={loading}
                    >
                      {'Novo'}
                    </Button>
                  ) : (
                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      sx={{ mt: 3 }}
                      startIcon={<Save />}
                      disabled={loading}
                    >
                      {'Salvar'}
                    </Button>
                  )}

                  <Button
                    type="button"
                    variant="contained"
                    size="large"
                    onClick={() => setMode('Busca')}
                    sx={{ mt: 3, marginLeft: 2, backgroundColor: '#7469ea' }}
                    startIcon={mode === 'create' ? <KeyboardReturnIcon /> : <Search />}
                    disabled={loading}
                  >
                    {'Voltar'}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Paper>
        </Container>
        :
        <Container sx={{ py: 3 }}>
          <Paper elevation={3} sx={{ p: 4 }}>
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Person sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
              <Typography variant="h5" gutterBottom>
                Editais
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            {success && (
              <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
                {success}
              </Alert>
            )}

            <form className='admin-form' onSubmit={handleSubmit(onSubmitBusca)}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    className='col'
                    label="Título"
                    margin="normal"
                    {...register('titulo', {
                      minLength: {
                        value: 3,
                        message: 'Título deve ter no mínimo 3 caracteres'
                      }
                    })}
                    error={!!errors.nome}
                    helperText={errors.nome?.message}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    className='col'
                    label="Descrição"
                    margin="normal"
                    {...register('descricao', {
                      minLength: {
                        value: 3,
                        message: 'Descrição deve ter no mínimo 3 caracteres'
                      }
                    })}
                    error={!!errors.nome}
                    helperText={errors.nome?.message}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Data de Início"
                    type="date"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    {...register('data_inicio')}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Data de Fim"
                    type="date"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    {...register('data_fim')}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Status"
                    margin="normal"
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  {mode !== 'create' ? (
                    <Button
                      onClick={() => setMode('create')}
                      variant="contained"
                      size="large"
                      sx={{ mt: 3 }}
                      startIcon={<Save />}
                      disabled={loading}
                    >
                      {'Novo'}
                    </Button>
                  ) : (
                    <Button
                      onClick={() => setMode('create')}
                      variant="contained"
                      size="large"
                      sx={{ mt: 3 }}
                      startIcon={<Save />}
                      disabled={loading}
                    >
                      {'Salvar'}
                    </Button>
                  )}

                  <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    sx={{ mt: 3, marginLeft: 2, backgroundColor: '#ccdb00' }}
                    startIcon={mode === 'create' ? <KeyboardReturnIcon /> : <Search />}
                    disabled={loading}
                  >
                    {mode === 'create' ? 'Voltar' : 'Buscar'}
                  </Button>
                </Grid>
              </Grid>
            </form>

            {rows && mode !== 'create' && mode !== 'edit' && (
              <React.Fragment>
                <TableContainer component={Paper}>
                  <Table aria-label="collapsible table">
                    <TableHead>
                      <TableRow>
                        <TableCell />
                        <TableCell>Título</TableCell>
                        <TableCell align="right">Descrição</TableCell>
                        <TableCell align="right">Data de Início</TableCell>
                        <TableCell align="right">Data de Fim</TableCell>
                        <TableCell align="right">Status</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => (
                          <Row key={row.id} row={row} handleEdit={handleEdit} />
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <TablePagination
                  component="div"
                  count={rows.length}
                  page={page}
                  onPageChange={(e, newPage) => setPage(newPage)}
                  rowsPerPage={rowsPerPage}
                  onRowsPerPageChange={(e) => {
                    setRowsPerPage(parseInt(e.target.value, 10));
                    setPage(0);
                  }}
                  rowsPerPageOptions={[5, 10, 25]}
                  labelRowsPerPage="Linhas por página"
                />
              </React.Fragment>
            )}
          </Paper>
        </Container>
      }
    </Box>
  );
};

const Row = (props) => {
  const { row, handleEdit } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow onClick={() => handleEdit(row)} sx={{ '& > *': { borderBottom: 'unset' }, cursor: "pointer" }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.titulo}
        </TableCell>
        <TableCell align="right">{row.descricao}</TableCell>
        <TableCell align="right">{!row.data_inicio || row.data_inicio === '0000-00-00' ? '' : format(parseISO(row.data_inicio), 'dd/MM/yyyy')}</TableCell>
        <TableCell align="right">{!row.data_fim || row.data_fim === '0000-00-00' ? '' : format(parseISO(row.data_fim), 'dd/MM/yyyy')}</TableCell>
        <TableCell align="right">{row.status}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                Gêneros Alimentícios
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Gênero Alimentício</TableCell>
                    <TableCell align="right">Quantidade</TableCell>
                    <TableCell align="right">Unidade</TableCell>
                    <TableCell align="right">Valor</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.alimentos && row.alimentos.map((alimento, idx) => (
                    <TableRow key={idx}>
                      <TableCell component="th" scope="row">
                        {alimento.nome}
                      </TableCell>
                      <TableCell align="right">{alimento.quantidade}</TableCell>
                      <TableCell align="right">{alimento.unidademedida}</TableCell>
                      <TableCell align="right">{alimento.valor}</TableCell>
                    </TableRow>
                  ))}
                  {(!row.alimentos || row.alimentos.length === 0) && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">Nenhum alimento cadastrado ou carregue os detalhes editando o edital</TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export default Formedital

